import React from 'react';

import Box from '@amzn/meridian/box';
import Text from '@amzn/meridian/text';
import { AdminConfigNavConsts } from 'src/store/adminConfigPageSlice/common/constants';
import { useAppSelector } from 'src/store/store';

import './restrictionFormConfiguration.scss';

import RestrictionFormsTableContainer from './restrctionFormsTableContainer/restrictionFormsTableContainer';
import RestrictionFormConfigurationTabGroup from './restrictionFormConfigurationTabGroup/restrictionFormConfigurationTabGroup';
import FormTaskConfiguration from './formTaskConfiguration/formTaskConfiguration';

// **** Components **** //

/**
 * Default component.
 */
const RestrictionFormConfiguration = () => {
  return (
    <div className="view-and-edit-forms">
      <Text className="view-and-edit-forms__content__text">
        Here you can update the regional work Restriction/Requirement forms available within the RTW tool
      </Text>
      <div>
        <RestrictionFormConfigurationTabs />
      </div>
    </div>
  );
};

/**
 * Toggle between the
 */
const RestrictionFormConfigurationTabs = () => {
  const { selectedFormTab } = useAppSelector((state) => state.adminConfigPage);
  return (
    <div className="view-and-edit-forms">
      <Box spacingInset="100 none none none">
        <RestrictionFormConfigurationTabGroup />
      </Box>
      <Box type="outline" spacingInset="200 500 400 500">
        {selectedFormTab === AdminConfigNavConsts.Form.Table.TAB ? (
          <RestrictionFormsTableContainer />
        ) : selectedFormTab === AdminConfigNavConsts.Form.Edit.TAB ? (
          <FormTaskConfiguration />
        ) : null}
      </Box>
    </div>
  );
};

// **** Export **** //

export default RestrictionFormConfiguration;
